import React from 'react';
import {Tag} from 'antd';
import utils from '../../utils';
import fetch from '../fetch';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号',
    },
    {
        key: 'majorName',
        label: '专业名称',
    },
    {
        key: 'belongOrgName',
        label: '所属院系/学院',
    },
    {
        key: 'principalCode',
        label: '专业负责人工号',
        width: 150
    },
    {
        key: 'principalName',
        label: '专业负责人姓名',
        width: 150
    },
    {
        key: 'no',
        label: '编号'
    },
    {
        key: 'version',
        label: '版本'
    },
    {
        key: 'authenticationNumber',
        label: '认证序号'
    },
    {
        key: 'submitDate',
        label: '提交日期'
    },
    {
        key: 'principalPhone',
        label: '专业负责人联系电话'
    },
    {
        key: 'createTime',
        label: '创建时间'
    }
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('zgcp/base/info/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}


const remove = (ids) => {
    return fetch.post('zgcp/base/info/delete', ids)
    .then(res => {
        if (res && res.code === 200) {
            return res.payload.data;
        }
    })
}

const insert = (data) => {
    return fetch.post('zgcp/base/info/insert', data)
    .then(res => {
        if (res && res.code === 200) {
            return res.payload.data;
        }
    })
}

const update = (data) => {
    return fetch.post('zgcp/base/info/update', data)
    .then(res => {
        if (res && res.code === 200) {
            return res.payload.data;
        }
    })
}

const getDetail = (id) => {
    return fetch.get(`zgcp/base/info/getDetail/${id}`)
    .then(res => {
        if (res && res.code === 200) {
            return res.payload.data;
        }
    })
}

const insertDetail = (data) => {
    return fetch.post(`zgcp/base/info/insertDetail`, data)
    .then(res => {
        if (res && res.code === 200) {
            return res.payload.data;
        }
    })
}

const getById = (id) => {
    return fetch.get(`zgcp/base/info/get/${id}`)
    .then(res => {
        if (res && res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    columns,
    querySearch,
    getDetail,
    remove,
    insert,
    update,
    insertDetail,
    getById
}